import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Problem() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-135">
      {/* Subtle background glow */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-cyan-500/5 blur-[150px] pointer-events-none" data-id="element-136" />

      <div className="max-w-4xl mx-auto" data-id="element-137">
        <FadeIn data-id="element-138">
          <div className="relative p-8 sm:p-12 rounded-2xl border border-white/5 bg-white/[0.02] backdrop-blur-sm" data-id="element-139">
            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-gold-500/30 rounded-tl-2xl" data-id="element-140" />
            <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-gold-500/30 rounded-br-2xl" data-id="element-141" />

            <h3 className="text-sm font-bold tracking-widest text-gold-400 uppercase mb-8 flex items-center gap-4" data-id="element-142">
              <span className="w-8 h-[1px] bg-gold-400/50" data-id="element-143"></span>
              La Ilusión del Personaje
            </h3>

            <div className="space-y-8 text-lg sm:text-xl text-gray-300 font-light leading-relaxed" data-id="element-144">
              <p data-id="element-145">
                Estás agotado de intentar "manifestar" una vida mejor mientras
                sigues atrapado en la mente. Sientes que el tiempo se te escapa
                como arena entre los dedos, repitiendo los mismos patrones de
                dolor, los mismos miedos y las mismas crisis que parecen no
                tener fin.
              </p>
              <p data-id="element-146">
                Crees que eres tu nombre, tu historia y tus traumas. Vives en el
                pasado que ya no existe o en el futuro que te aterra, dejando tu
                energía vital completamente seca en el ahora. Estás jugando la
                partida en "modo supervivencia", siendo fiel a una ignorancia
                que te susurra que eres una víctima de las circunstancias.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}